/*
 * Keeps the phone model the same inside one bundle in the cart.
 * Bundle lines carry the hidden properties _bundle and _bundle_id (added by product-bundle.js).
 * When the shopper changes the model of one bundle line in the cart (case, screen or
 * camera lens protector), the other model lines of the same bundle are switched to that model.
 * If an item has no variant for the new model, it stays in the cart with a visible note.
 * Lines without a phone model (power bank, ring, strap) are not touched.
 */
(function () {
  if (window.__cartBundleSyncInit) return;
  window.__cartBundleSyncInit = true;

  var STORE_KEY = 'bundle-models';
  var NOTE_KEY = 'Note';
  var MODEL_RE = /(iphone|samsung|galaxy|pixel|xiaomi|redmi|oneplus|huawei|motorola|nothing)/i;
  var syncing = false;
  var pending = false;
  var timer = null;
  var productCache = {};

  function normModel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\bgalaxy\b/g, '')
      .replace(/\b[45]g\b/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function noteText(model) {
    return (window.bundleSyncNote || 'Does not fit [model]').replace('[model]', model);
  }

  function readStore() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeStore(data) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function json(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  function getProduct(handle) {
    if (!productCache[handle]) productCache[handle] = json('/products/' + handle + '.js');
    return productCache[handle];
  }

  function isModelLine(line) {
    return !!line.variant_title && MODEL_RE.test(line.variant_title);
  }

  function isCaseLine(line) {
    return !!(line.properties && line.properties['Case Type']);
  }

  // Which model should the bundle have? The one that differs from the last known model
  // (= the line the shopper just changed). Without history: the case's model.
  function targetModel(lines, previous) {
    var models = lines.map(function (l) {
      return l.variant_title;
    });
    if (previous) {
      var changed = models.find(function (m) {
        return normModel(m) !== normModel(previous);
      });
      if (changed) return changed;
      return previous;
    }
    var caseLine = lines.find(isCaseLine);
    return caseLine ? caseLine.variant_title : models[0];
  }

  function refreshDrawer() {
    var api = window.kachingCartApi;
    if (api && typeof api.refreshCart === 'function') {
      try {
        api.refreshCart();
      } catch (e) {}
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-bundle-sync' });
    }
  }

  /*
   * Bundle safety net across page loads: product-bundle.js saves every bundle add
   * in sessionStorage "bundle-jobs". If the case line of a bundle is in the cart but
   * its accessories are not (page reloaded, add request lost), add them once.
   */
  var JOB_WAIT = 6000; // product-bundle.js adds them itself within a few seconds
  var JOB_MAX_AGE = 15 * 60 * 1000;
  // product-bundle.js did send the accessories, but another cart write running at the
  // same moment (e.g. Kaching saving its cart attributes) can drop them on Shopify's
  // side even after a 200 response. Check once more and add them again, only shortly
  // after the bundle was added (a shopper removing them later is respected).
  var RETRY_QUIET = 1200; // no cart write for this long before checking
  var RETRY_FALLBACK = 10000; // if the accessories request was not seen, check after this
  var RETRY_UNTIL = 20000;
  var SEEN_WATCH = 6000; // keep watching this long after the accessories showed up
  var addEnds = []; // when /cart/add requests came back (Date.now())
  var lastWriteEnd = 0; // when the last cart write came back
  var lastChangeEnd = 0; // when the last /cart/change came back (removing a line, qty)
  var jobTimer = null;
  // true while a bundle's accessories are still on their way: this script then makes
  // no cart writes of its own, so it cannot overwrite them
  var bundleInFlight = false;

  function readJobs() {
    try {
      return JSON.parse(sessionStorage.getItem('bundle-jobs') || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeJobs(jobs) {
    try {
      sessionStorage.setItem('bundle-jobs', JSON.stringify(jobs));
    } catch (e) {}
  }

  function isBundleCaseLine(line, job) {
    var p = line.properties || {};
    if (p._bundle_case || p['Case Type']) return true;
    return !!(job && job.caseItem && String(line.variant_id) === String(job.caseItem.id));
  }

  function finishBundleJobs(cart) {
    var jobs = readJobs();
    var ids = Object.keys(jobs);
    bundleInFlight = false;
    if (!ids.length) return Promise.resolve(false);
    var now = Date.now();
    var toAdd = [];
    var waiting = false;
    var fastPoll = false;
    var quiet = now - lastWriteEnd >= RETRY_QUIET;
    var shopperChanged = function (job) {
      return lastChangeEnd > job.at;
    };
    ids.forEach(function (id) {
      var job = jobs[id];
      if (!job || now - job.at > JOB_MAX_AGE) {
        delete jobs[id];
        return;
      }
      var lines = cart.items.filter(function (l) {
        return l.properties && l.properties._bundle_id === id;
      });
      var hasCase = lines.some(function (l) {
        return isBundleCaseLine(l, job);
      });
      var accessories = lines.length - (hasCase ? 1 : 0);
      if (hasCase && !job.caseSeenAt) job.caseSeenAt = now;

      if (!hasCase && accessories > 0) {
        // accessories without their case: the case add was dropped by a cart write of
        // another app (Kaching) that ran at the same moment. Add the case once more.
        if (job.caseRetried || !job.caseItem || now - job.at > RETRY_UNTIL || shopperChanged(job)) {
          delete jobs[id];
          return;
        }
        if (job.caseSeenAt && now - job.caseSeenAt > SEEN_WATCH) {
          delete jobs[id]; // the case was in the cart a while: the shopper removed it
          return;
        }
        if (!quiet) {
          waiting = true;
          bundleInFlight = true;
          fastPoll = true;
          return;
        }
        job.caseRetried = true;
        job.caseSeenAt = 0;
        toAdd.push(job.caseItem);
        return;
      }

      if (hasCase && accessories > 0) {
        // complete. Keep watching a few seconds: a cart write by another app that
        // started before the accessories were added can still drop them.
        if (!job.seenAt) job.seenAt = now;
        if (now - job.seenAt < SEEN_WATCH) {
          waiting = true;
          fastPoll = true;
        } else {
          delete jobs[id];
        }
        return;
      }

      if (!lines.length) {
        // case not in the cart yet: wait for it shortly. Once the accessories were
        // sent (or after 15 s) an empty bundle means the shopper removed it.
        if (!job.done && now - job.at < 15000) {
          waiting = true;
          bundleInFlight = true;
        } else {
          delete jobs[id];
        }
        return;
      }

      // only the case of this bundle is in the cart
      if (!job.done) {
        // product-bundle.js has not sent the accessories yet
        if (now - job.at < JOB_WAIT) {
          waiting = true;
          bundleInFlight = true;
          return;
        }
        job.done = true;
        toAdd = toAdd.concat(job.items || []);
        return;
      }
      if (job.retried || now - job.at > RETRY_UNTIL || shopperChanged(job)) {
        delete jobs[id];
        return;
      }
      if (job.seenAt && now - job.seenAt > SEEN_WATCH) {
        // they were in the cart a while ago: the shopper removed them
        delete jobs[id];
        return;
      }
      // accessories were sent but are not in the cart. Wait until their request has
      // come back and the cart is quiet (a request still on its way is not doubled).
      var addsBack = addEnds.filter(function (t) {
        return t > job.at;
      }).length;
      var ready = (job.seenAt || addsBack >= 2 || now - job.at >= RETRY_FALLBACK) && quiet;
      if (!ready) {
        waiting = true;
        bundleInFlight = true;
        fastPoll = true;
        return;
      }
      job.retried = true;
      job.seenAt = 0;
      toAdd = toAdd.concat(job.items || []);
    });
    writeJobs(jobs);
    clearTimeout(jobTimer);
    if (waiting) jobTimer = setTimeout(schedule, fastPoll ? 1000 : 3000);
    if (!toAdd.length) return Promise.resolve(false);
    return json('/cart/add.js', { items: toAdd }).then(function () {
      return true;
    });
  }

  // Remember how the case of a bundle was added (variant, Easify properties), so it
  // can be added again if another app's cart write drops it. Runs after the
  // product form read its data (bubble phase), while the bundle inputs are still there.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    try {
      var data = new FormData(form);
      var bundleId = data.get('properties[_bundle_id]');
      if (!bundleId) return;
      var properties = {};
      data.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m && typeof value === 'string') properties[m[1]] = value;
      });
      var jobs = readJobs();
      if (!jobs[bundleId]) return;
      jobs[bundleId].caseItem = {
        id: parseInt(data.get('id'), 10),
        quantity: parseInt(data.get('quantity') || '1', 10) || 1,
        properties: properties,
      };
      writeJobs(jobs);
    } catch (e) {}
  });

  function reconcile() {
    if (syncing) return;
    syncing = true;
    json('/cart.js')
      .then(function (cart) {
        return finishBundleJobs(cart)
          .catch(function () {
            return false;
          })
          .then(function (added) {
            return added ? json('/cart.js') : cart;
          });
      })
      .then(function (cart) {
        if (bundleInFlight) return false;
        var store = readStore();
        var groups = {};
        cart.items.forEach(function (line) {
          var id = line.properties && line.properties._bundle_id;
          if (!id || !isModelLine(line)) return;
          (groups[id] = groups[id] || []).push(line);
        });

        var jobs = [];
        var nextStore = {};
        Object.keys(groups).forEach(function (id) {
          var lines = groups[id];
          var target = targetModel(lines, store[id]);
          nextStore[id] = target;
          lines.forEach(function (line) {
            var hasNote = line.properties && line.properties[NOTE_KEY];
            if (normModel(line.variant_title) === normModel(target)) {
              // matching again: remove an old note
              if (hasNote) {
                var props = Object.assign({}, line.properties);
                delete props[NOTE_KEY];
                jobs.push(function () {
                  return json('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props });
                });
              }
              return;
            }
            jobs.push(function () {
              return getProduct(line.handle).then(function (product) {
                var variant = product.variants.find(function (v) {
                  return v.available && normModel(v.title) === normModel(target);
                });
                var props = Object.assign({}, line.properties);
                if (!variant) {
                  var note = noteText(target);
                  if (props[NOTE_KEY] === note) return null;
                  props[NOTE_KEY] = note;
                  return json('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props });
                }
                delete props[NOTE_KEY];
                // replace the line: add the new model, then remove the old one
                return json('/cart/add.js', {
                  items: [{ id: variant.id, quantity: line.quantity, properties: props }],
                }).then(function () {
                  return json('/cart/change.js', { id: line.key, quantity: 0 });
                });
              });
            });
          });
        });

        writeStore(nextStore);
        if (!jobs.length) return false;
        // run one after another (cart API does not like parallel writes)
        return jobs
          .reduce(function (chain, job) {
            return chain.then(job);
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .then(function (changed) {
        if (changed) refreshDrawer();
        if (bundleInFlight) return;
        return syncBundleAttribute();
      })
      .then(function () {
        return updateCartModel();
      })
      .catch(function (e) {
        console.warn('cart bundle sync', e);
      })
      .finally(function () {
        setTimeout(function () {
          syncing = false;
          // a cart change arrived while we were syncing (e.g. Kaching finished
          // replacing a line): check again
          if (pending) {
            pending = false;
            schedule();
          }
        }, 400);
      });
  }

  /*
   * Discount function (SupaEasy) cannot read line properties, so the bundles are also
   * written to one cart attribute: [[caseVariantId, caseQty, [[variantId, qty], ...]], ...]
   * The function checks every entry against the real cart before giving -20%.
   */
  var BUNDLE_ATTR = '_bundles';

  function bundleAttributeValue(cart) {
    var groups = {};
    var order = [];
    cart.items.forEach(function (line) {
      var id = line.properties && line.properties._bundle_id;
      if (!id) return;
      if (!groups[id]) {
        groups[id] = { caseLine: null, items: [] };
        order.push(id);
      }
      if (isCaseLine(line) && !groups[id].caseLine) groups[id].caseLine = line;
      else groups[id].items.push([line.variant_id, line.quantity]);
    });
    var out = [];
    order.forEach(function (id) {
      var g = groups[id];
      if (!g.caseLine) return; // no case = no bundle
      if (!g.items.length) {
        // accessories still on their way: use the bundle saved by product-bundle.js,
        // so the discount is ready as soon as they arrive (no second price jump)
        var job = readJobs()[id];
        if (!job || !job.items || Date.now() - job.at > 60000) return; // the discount function checks the items are really in the cart
        g.items = job.items.map(function (item) {
          return [item.id, item.quantity || 1];
        });
      }
      out.push([g.caseLine.variant_id, g.caseLine.quantity, g.items]);
    });
    return out.length ? JSON.stringify(out) : '';
  }

  function syncBundleAttribute() {
    return json('/cart.js').then(function (cart) {
      var value = bundleAttributeValue(cart);
      var current = (cart.attributes && cart.attributes[BUNDLE_ATTR]) || '';
      if (value === current) return;
      var attributes = {};
      attributes[BUNDLE_ATTR] = value;
      // the discount changes with this attribute: redraw the cart drawer prices
      return json('/cart/update.js', { attributes: attributes }).then(refreshDrawer);
    });
  }

  function schedule() {
    if (syncing) {
      pending = true;
      return;
    }
    clearTimeout(timer);
    // Kaching changes a model with several requests: wait until they are done
    timer = setTimeout(reconcile, 700);
  }

  // Every cart write (theme, Kaching cart, apps) shows up as a resource entry,
  // whichever fetch wrapper made it
  if (typeof PerformanceObserver === 'function') {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (/\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(entry.name)) {
            var t = Date.now();
            lastWriteEnd = t;
            if (/\/cart\/change(\.js)?(\?|$)/.test(entry.name)) lastChangeEnd = t;
            if (/\/cart\/add(\.js)?(\?|$)/.test(entry.name)) {
              addEnds.push(t);
              if (addEnds.length > 20) addEnds.shift();
            }
            schedule();
          }
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  /* ----- Kaching cart upsell: preselect the model of the case in the cart ----- */
  var cartModel = null;
  var touched = typeof WeakSet === 'function' ? new WeakSet() : null;

  function currentCartModel(cart) {
    var lines = cart.items.filter(isModelLine);
    // Shopify lists the newest line first: use the most recently added case
    var caseLine = lines.filter(isCaseLine)[0];
    var line = caseLine || lines[0];
    return line ? line.variant_title : null;
  }

  function updateCartModel() {
    return json('/cart.js')
      .then(function (cart) {
        cartModel = currentCartModel(cart);
        preselectUpsells();
      })
      .catch(function () {});
  }

  function preselectUpsells() {
    if (!cartModel) return;
    var target = normModel(cartModel);
    // only the "Add more protection" upsell, never the selectors of cart lines
    var selects = document.querySelectorAll('.kaching-upsell-module--product-upsell select');
    var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    Array.prototype.forEach.call(selects, function (select) {
      if (touched && touched.has(select)) return; // shopper chose a model himself
      if (!select.__bundleSyncListen) {
        select.__bundleSyncListen = true;
        select.addEventListener('change', function (event) {
          if (event.isTrusted && touched) touched.add(select);
        });
      }
      var option = Array.prototype.find.call(select.options, function (o) {
        return normModel(o.value) === target || normModel(o.text) === target;
      });
      if (!option || select.value === option.value) return;
      setter.call(select, option.value);
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Kaching re-renders the drawer: apply again when its content changes
  // Model changed in the cart drawer: Kaching sends its requests through its own
  // API layer (not always visible above), so react to the select itself.
  document.addEventListener(
    'change',
    function (event) {
      var el = event.target;
      if (!el || el.tagName !== 'SELECT' || !el.closest) return;
      if (!el.closest('kaching-cart-drawer, kaching-cart, cart-drawer')) return;
      if (el.closest('.kaching-upsell-module--product-upsell')) return;
      // check after Kaching has replaced the line (twice, in case the first is too early)
      setTimeout(schedule, 1200);
      setTimeout(schedule, 3500);
    },
    true
  );

  var upsellTimer = null;
  var drawerTimer = null;
  new MutationObserver(function (mutations) {
    var inCart = mutations.some(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      return el && el.closest && el.closest('kaching-cart-drawer, kaching-cart, cart-drawer');
    });
    if (!inCart) return;
    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(preselectUpsells, 150);
    // backup trigger: the cart drawer re-rendered after a change the
    // resource observer did not report
    clearTimeout(drawerTimer);
    drawerTimer = setTimeout(schedule, 600);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // remember the current models on page load
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();